/** Rutas de API usadas en event logs (pathname absoluto). */
export const EVENT_LOG_ENDPOINTS = {
  AUTH_LOGIN: '/api/transportista/login',
  AUTH_DATOS_USUARIO: '/api/transportista/datos-usuario',
  CHECKLIST_FORM: '/api/transportista/eval-mixer/form',
  CHECKLIST_SET: '/api/transportista/eval-mixer/set',
  FATIGA_LIST: '/api/transportista/fatiga/list',
  FATIGA_INSERT: '/api/transportista/fatiga/insert',
  FATIGA_UPDATE: '/api/transportista/fatiga/update',
  COMBUSTIBLE_LIST: '/api/transportista/combustible/list',
  COMBUSTIBLE_ARI_LIST: '/api/transportista/combustible/ari/list',
  COMBUSTIBLE_INSERT: '/api/transportista/combustible/insert',
  COMBUSTIBLE_UPDATE: '/api/transportista/combustible/update',
  COMBUSTIBLE_ARI_INSERT: '/api/transportista/combustible/ari/insert',
  COMBUSTIBLE_ARI_UPDATE: '/api/transportista/combustible/ari/update',
  VIAJES_LIST: '/api/transportista/viajes',
  VIAJES_FIRMA: '/api/transportista/viajes/firma',
  VIAJES_SET_VALUES: '/api/transportista/viajes/set-values',
  SEGUIMIENTO_VIAJES: '/api/seguimiento-anonimo/viajes',
  SEGUIMIENTO_FIRMA: '/api/seguimiento-anonimo/viajes/firma',
} as const;

export function combustibleListEndpoint(tipo: 'mixer' | 'arido'): string {
  return tipo === 'arido'
    ? EVENT_LOG_ENDPOINTS.COMBUSTIBLE_ARI_LIST
    : EVENT_LOG_ENDPOINTS.COMBUSTIBLE_LIST;
}

export function combustibleSaveEndpoint(
  tipo: 'mixer' | 'arido',
  isEdit: boolean
): string {
  if (tipo === 'arido') {
    return isEdit
      ? EVENT_LOG_ENDPOINTS.COMBUSTIBLE_ARI_UPDATE
      : EVENT_LOG_ENDPOINTS.COMBUSTIBLE_ARI_INSERT;
  }
  return isEdit
    ? EVENT_LOG_ENDPOINTS.COMBUSTIBLE_UPDATE
    : EVENT_LOG_ENDPOINTS.COMBUSTIBLE_INSERT;
}
